import { render, staticRenderFns } from "./DocStag.vue?vue&type=template&id=028871ae"
import script from "./DocStag.vue?vue&type=script&lang=js"
export * from "./DocStag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports